import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { useState, useEffect } from 'react';
import IconSvg from 'src/assets/icons/IconSvg';
import Button from '../button/Button';
import { useViewport } from 'src/context/ViewportContext';
import type { LeaderboardPeriod } from 'src/types/leaderboard';

interface Props {
  btnClass?: string;
  period: LeaderboardPeriod;
  onApply: (period: LeaderboardPeriod) => void;
}

const periods: { key: LeaderboardPeriod; label: string }[] = [
  { key: '7d', label: '7D' },
  { key: '30d', label: '30D' },
  { key: '90d', label: '90D' },
  { key: 'all', label: 'All' },
];

const LeaderboardFilterMenu = ({ btnClass, period, onApply }: Props) => {
  const [selectedPeriod, setSelectedPeriod] = useState<LeaderboardPeriod>(period);
  const { isMobile } = useViewport();

  useEffect(() => {
    setSelectedPeriod(period);
  }, [period]);

  const handleApply = () => {
    onApply(selectedPeriod);
  };

  return (
    <Menu>
      <MenuButton
        className={`xl:p-2.5 w-[40px] h-[40px] xl:w-fit xl:h-fit rounded-lg bg-grayscale-900 border border-grayscale-700 text-grayscale-300 flex items-center justify-center flex-shrink-0 ${btnClass}`}
      >
        <IconSvg icon={isMobile ? 'filtersS' : 'filtersM'} />
      </MenuButton>

      <MenuItems
        transition
        anchor="bottom end"
        className="z-50 px-4 py-3 rounded-lg bg-grayscale-900 w-[220px] space-y-3 !mt-1.5"
      >
        <div className="space-y-1">
          <div className="text-grayscale-400 text-sm">Time Period</div>
          <div className="flex gap-2">
            {periods.map((item) => (
              <button
                key={item.key}
                className={`px-3 py-2 rounded-lg bg-brand-black text-brand-granite text-sm text-center ${
                  selectedPeriod === item.key ? '!bg-grayscale-700 text-brand-magnolia' : ''
                }`}
                onClick={() => setSelectedPeriod(item.key)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <MenuItem as="div">
          <Button variant="secondary" size="sm" className="w-full" onClick={handleApply}>
            Apply Filters
          </Button>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default LeaderboardFilterMenu;
